import {DataGrid, GridRenderCellParams} from '@mui/x-data-grid';
import {Box, Stack} from '@mui/material';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {expenseTAMasterStateSelector} from '@app/screens/master-data-management/pages/expense-ta-master/redux/selectors';
import {Gridstyle} from '@app/components/widgets/grid/grid';
import {useCallback, useEffect, useState} from 'react';
import {renderDateCell} from '@app/screens/configuration-management/components/expense-type-setting-grid';
import {expenseTAMasterStateActions} from '@app/screens/master-data-management/pages/expense-ta-master/redux';
import {
  filterSelector,
  filterStateActions,
} from '@app/components/right-sidebar/redux';
import {fetchExpenseTAMasterGridCreator} from '@app/screens/master-data-management/pages/expense-ta-master/redux/slice';
import {strings} from '@app/common/strings';

export const ExpenseTAGrid = ({gridData}: {gridData: any}) => {
  const dispatch = useDispatch();
  const expenseTAMasterLoading = useSelector(
    expenseTAMasterStateSelector.getExpenseTAMasterLoading(),
  );

  const expenseTAMasterPageno = useSelector(
    expenseTAMasterStateSelector.getPage(),
  );
  const expenseTAMasterPagesize = useSelector(
    expenseTAMasterStateSelector.getPageSize(),
  );
  const totalCount = useSelector(
    expenseTAMasterStateSelector.getTotalCount(),
    shallowEqual,
  );
  const request = useSelector(filterSelector.getFilterOptions());
  const [pageSize, setPageSize] = useState(expenseTAMasterPagesize);
  const [pageNo, setPageNo] = useState(expenseTAMasterPageno);

  const noRowsOverlayComponent = useCallback(
    () => (
      <Stack height="100%" alignItems="center" justifyContent="center">
        {strings.noRecordFound}
      </Stack>
    ),
    [],
  );
  const getRowIdHandlerExpTAMaster = useCallback(function (row: any) {
    return row?.expenseTAMasterId;
  }, []);
  const PageSizeChangeExpTAMaster = useCallback(
    function (newPageSize: any) {
      return setPageSize(newPageSize);
    },
    [pageSize],
  );

  const PageChangeExpTAMaster = useCallback(
    function (newPageNo: any) {
      return setPageNo(newPageNo);
    },
    [pageNo],
  );
  useEffect(() => {
    dispatch(expenseTAMasterStateActions.setPage(pageNo));
    dispatch(expenseTAMasterStateActions.setPageSize(pageSize));
    if (Number(pageNo) * Number(pageSize) > totalCount) {
      dispatch(expenseTAMasterStateActions.setPage(0));
      dispatch(
        filterStateActions.setFilterOptions({
          ...request,
          pageNumber: 0,
          pageLimit: pageSize,
        }),
      );
    } else {
      dispatch(
        filterStateActions.setFilterOptions({
          ...request,
          pageNumber: pageNo,
          pageLimit: pageSize,
        }),
      );
    }

    dispatch(fetchExpenseTAMasterGridCreator(null));
  }, [pageNo, pageSize]);

  useEffect(() => {
    setPageNo(expenseTAMasterPageno);
    setPageSize(expenseTAMasterPagesize);
  }, [expenseTAMasterPageno, expenseTAMasterPagesize]);

  const columns = [
    {field: strings.masterDataManagement.expenseTAMasterId, hide: true},
    {
      field: strings.tableHeader.division,
      headerName: strings.division,
      width: 120,
      editable: false,
      renderCell: (params: GridRenderCellParams<any>) => {
        return <p>{params?.row?.division}</p>;
      },
    },
    {
      field: strings.tableHeader.designation,
      headerName: strings.designation,
      width: 230,
      editable: false,
      renderCell: (params: GridRenderCellParams<any>) => {
        return <p>{params?.row?.designation}</p>;
      },
    },

    {
      field: strings.tableHeader.hq,
      headerName: strings.hq,
      width: 220,
      editable: false,
      renderCell: (params: GridRenderCellParams<any>) => {
        return <p>{params?.row?.hq}</p>;
      },
    },
    {
      field: strings.tableHeader.taPerKM,
      headerName: strings.taPerKm,
      width: 100,
      editable: false,
    },
    {
      field: strings.startDate,
      editable: false,
      headerName: strings.effectiveForm,
      width: 120,
      renderCell: (params: GridRenderCellParams<any>) => {
        return renderDateCell(params?.row?.startDate);
      },
    },
    {
      field: strings.endDate,
      width: 120,
      headerName: strings.validUpto,
      renderCell: (params: GridRenderCellParams<any>) => {
        return renderDateCell(params?.row?.endDate);
      },
      editable: false,
    },
  ];
  return (
    <Box sx={Gridstyle.gridcss}>
      <DataGrid
        pagination
        paginationMode="server"
        rows={gridData ?? []}
        page={pageNo}
        rowCount={
          Number(pageNo) * Number(pageSize) > totalCount
            ? Number(pageNo) * Number(pageSize)
            : totalCount
        }
        loading={expenseTAMasterLoading}
        getRowId={getRowIdHandlerExpTAMaster}
        columns={columns}
        pageSize={pageSize}
        rowsPerPageOptions={[10, 20, 50, 100]}
        onPageSizeChange={PageSizeChangeExpTAMaster}
        onPageChange={PageChangeExpTAMaster}
        components={{
          NoRowsOverlay: noRowsOverlayComponent,
        }}
      />
    </Box>
  );
};
